import { z } from 'zod';
import { OmniFieldSchema } from './fields.js';
import { OmniFilterSchema } from './filters.js';
const OmniTotalsSchema = z.record(OmniFieldSchema, z.strictObject({ type: z.literal('aggregation') }));
export const OmniQueryOptionsSchema = z.strictObject({
    fields: z
        .array(OmniFieldSchema)
        .min(1)
        .describe('Select only needed dimensions and measures. Dimensions determine grouping; measures provide computed metrics.'),
    filters: z.record(OmniFieldSchema, OmniFilterSchema).default({}),
    sorts: z
        .array(z.strictObject({
        column_name: OmniFieldSchema,
        sort_descending: z.boolean(),
        is_column_sort: z.boolean().optional(),
        pivot_value_map: z.record(OmniFieldSchema, z.string().nullable()).optional(),
        subtotal_sort: OmniFieldSchema.optional(),
    }))
        .default([]),
    pivots: z.array(OmniFieldSchema).default([]),
    column_totals: OmniTotalsSchema.default({}),
    row_totals: OmniTotalsSchema.default({}),
    fill_fields: z.array(OmniFieldSchema).default([]).describe('Date/time fields to fill.'),
    transposed_measures: z
        .array(OmniFieldSchema)
        .default([])
        .describe('Measures to transpose into rows.'),
    default_group_by: z.boolean().default(true),
    periodOverPeriodTransposed: z.boolean().default(false),
    period_over_period_computations: z
        .array(z.strictObject({
        date_filter_field_name: OmniFieldSchema,
        periods_ago: z.number().nullable(),
        time_unit_name: z.string().nullable(),
        is_dynamic_previous_period: z.boolean().optional(),
    }))
        .default([]),
});
//# sourceMappingURL=queryOptions.js.map